import styled, { css } from "styled-components";

interface ButtonStyleProps {
  $size:
    | "headerIcon"
    | "headerTextIcon"
    | "headerText"
    | "more"
    | "sm"
    | "md"
    | "lg"
    | "join"
    | "form"
    | "faqIcon"
    | "responsive";
  $color: "primary100" | "bright100" | "white100" | "black60";
  $width?: string | undefined;
  $layout: "solid" | "outline" | "text";
}

export const Buttons = styled.button<ButtonStyleProps>`
  gap: 4px;
  width: ${(props) => (props.$width ? props.$width : "100%")};
  cursor: pointer;
  display: flex;
  transition: all 0.2s ease;
  align-items: center;
  white-space: nowrap;
  border-radius: 6px;
  justify-content: center;
  box-sizing: border-box;

  // Size
  ${(props) =>
    props.$size === "join" &&
    css`
      width: auto;
      height: 40px;
      padding: 0 16px;
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 56px;
    `}

  ${(props) =>
    props.$size === "form" &&
    css`
      height: 56px;
      padding: 0 16px;
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 56px;
    `}

  ${(props) =>
    props.$size === "lg" &&
    css`
      height: 56px;
      padding: 0 16px;
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 56px;
    `}

    

  ${(props) =>
    props.$size === "md" &&
    css`
      gap: 6px;
      height: 48px;
      padding: 0 14px;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 48px;
    `}

  ${(props) =>
    props.$size === "sm" &&
    css`
      gap: 6px;
      height: 36px;
      padding: 0 10px;
      font-size: 1.3rem;
      font-weight: 700;
      line-height: 36px;
    `}

    ${(props) =>
    props.$size === "headerIcon" &&
    css`
      gap: 6px;
      width: unset;
      height: 40px;
      font-size: 1.4rem;
      min-width: 40px;
      font-weight: 400;
      line-height: 28px;
    `}

    ${(props) =>
    props.$size === "headerTextIcon" &&
    css`
      gap: 2px;
      width: unset;
      height: 40px;
      font-size: 1.3rem;
      min-width: 40px;
      font-weight: 600;
      line-height: 28px;
      white-space: nowrap;
      padding-inline: 4px 10px;
    `}

    ${(props) =>
    props.$size === "headerText" &&
    css`
      gap: 2px;
      width: unset;
      height: 40px;
      font-size: 1.3rem;
      min-width: 40px;
      font-weight: 600;
      line-height: 28px;
      padding-inline: 10px;
    `}

    ${(props) =>
    props.$size === "faqIcon" &&
    css`
      height: 20px;
      font-size: 1.3rem;
      min-width: 20px;
      font-weight: 600;
      line-height: 28px;
    `}

    ${(props) =>
    props.$size === "responsive" &&
    css`
      width: 42.2vw;
      height: 40px;
      padding: 0 16px;
      font-size: clamp(10px, 3.3vw, 20px);
      font-weight: 700;
      line-height: 56px;
      svg {
        width: clamp(16px, 4vw, 24px);
        height: clamp(16px, 4vw, 24px);
      }
    `}

    ${(props) =>
    props.$size === "more" &&
    css`
      gap: 2px;
      width: unset;
      height: 36px;
      padding: 4px 4px 4px 10px;
      font-size: 1.3rem;
      min-width: 36px;
      font-weight: 600;
      line-height: 28px;
    `}
  
  

  // Layout
  ${(props) =>
    props.$layout === "solid" &&
    css`
      color: ${props.$color === "white100"
        ? props.theme.colors.primary100
        : props.theme.colors.white100};
      border: none;
      background: ${props.theme.colors[props.$color]};

      &:hover,
      &:active {
        background: ${props.theme.colors[props.$color + "Hover"]};
      }

      &:disabled {
        cursor: default;
        background: ${props.theme.colors.black10};
      }
    `}


  ${(props) =>
    props.$layout === "text" &&
    css`
      color: ${props.theme.colors[props.$color]};
      border: none;
      background: none;

      &:hover,
      &:active {
        background: ${props.theme.colors.black5};
      }

      &:disabled {
        color: ${props.theme.colors.black10};
        cursor: default;
      }
    `}



  ${(props) =>
    props.$layout === "outline" &&
    css`
      color: ${props.theme.colors[props.$color]};
      border: 1px solid ${props.theme.colors[props.$color]};
      background: ${props.theme.colors.white100};

      &:hover,
      &:active {
        background: ${props.theme.colors.black5};
      }

      &:disabled {
        color: ${props.theme.colors.black10};
        cursor: default;
      }
    `}
`;
